import React, { useEffect, useState } from 'react'
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { Thunks } from '../../actions';
import { Button, CircularProgress, Dialog, DialogTitle } from '@mui/material';
import { EmptyState } from '@brightlayer-ui/react-components';
import * as PXBColors from '@brightlayer-ui/colors';
import { useSnackbar } from '../../providers/SnackBarProvider';

type Props = {
    username: string;
    userId: string;
    closeClick: Function;
    openDialogFlag: boolean;
}
const RestoreArchiveUserDialog = (props: Props) => {
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const userState = useSelector(Selectors.Users.users)
    const { success, error } = useSnackbar();

    function closeRemoveServiceUserDialog(): void {
        props.closeClick({});
    }

    const onCancel = () => {
        closeRemoveServiceUserDialog();
    }

    const onConfirmArchiveUser = (): void => {
        setLoader(true);
        dispatch(Thunks.Users.getArchiveUserList(props.userId, false));
    }

    useEffect(() => {
        if (!userState.archiveUserListLoading && userState.archiveUserListSuccess) {
            closeRemoveServiceUserDialog();
        } else if (!userState.archiveUserListLoading && userState.archiveUserListFail) {
            closeRemoveServiceUserDialog();
        }
    }, [userState.archiveUserListLoading, userState.archiveUserListSuccess, userState.archiveUserListFail]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Dialog data-testid='restoreUserDialog' id="restore-user-dialog" maxWidth="xs"
                open={props.openDialogFlag} onClose={closeRemoveServiceUserDialog}
            >
                {
                    loader && <EmptyState style={{ backgroundColor: PXBColors.gray[100], minHeight: 250, minWidth: 259 }}
                        icon={<CircularProgress id="progress-spinner" />} title={t('USERS.LOADER_HELPER_TEXT')} placeholder={undefined} />
                }
                {!loader && <>
                    <DialogTitle data-testid='dialogHeader'>{t('USER_INVITATION_MANAGEMENT.RESTORE_USER_DIALOG',
                        { replace: { userName: props.username, } }
                    )}
                    </DialogTitle>
                    <Button
                        style={{ alignSelf: 'end', marginTop: 10, marginBottom: 10, marginRight: 10 }}
                        id="restoreUserAccount"
                        data-testid="button-restore-user"
                        variant="text"
                        color="error"
                        onClick={onConfirmArchiveUser}
                    >
                        {t('USER_INVITATION_MANAGEMENT.RESTORE_USER_TITLE')}
                    </Button>

                    <Button style={{ alignSelf: 'end', marginBottom: 10, marginRight: 10 }} id="btnCancel" data-testid="btnCancel" variant="text" color="primary"
                        onClick={(): void => onCancel()}
                    >
                        {t('ACTIONS.CANCEL')}
                    </Button>
                </>}
            </Dialog>
        </>
    )
}

export default RestoreArchiveUserDialog
